/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.S40_MODELS = {
    'C1-01!'                                    : [ 'Nokia', 'C1-01' ],
    'C1-02!'                                    : [ 'Nokia', 'C1-02' ],
    'C1-03!'                                    : [ 'Nokia', 'C1-03' ],
    'C2-00!'                                    : [ 'Nokia', 'C2-00' ],
    'C2-01!'                                    : [ 'Nokia', 'C2-01' ],
    'C2-02!'                                    : [ 'Nokia', 'C2-02' ],
    'C2-03!'                                    : [ 'Nokia', 'C2-03' ],
    'C2-05!'                                    : [ 'Nokia', 'C2-05' ],
    'C2-06!'                                    : [ 'Nokia', 'C2-06' ],
    'C3-00!'                                    : [ 'Nokia', 'C3-00' ],
    'C3-01!'                                    : [ 'Nokia', 'C3-01' ],
    'X2-00!'                                    : [ 'Nokia', 'X2-00' ],
    'X2-01!'                                    : [ 'Nokia', 'X2-01' ],
    'X2-02!'                                    : [ 'Nokia', 'X2-02' ],
    'X2-03!'                                    : [ 'Nokia', 'X2-03' ],
    'X2-05!'                                    : [ 'Nokia', 'X2-05' ],
    'X3-00!'                                    : [ 'Nokia', 'X3-00' ],
    'X3-02!'                                    : [ 'Nokia', 'X3-02' ],
    '109'                                       : [ 'Nokia', '109' ],
    '110'                                       : [ 'Nokia', '110' ],
    '111'                                       : [ 'Nokia', '111' ],
    '111.1'                                     : [ 'Nokia', '111' ],
    '112'                                       : [ 'Nokia', '112' ],
    '114'                                       : [ 'Nokia', '114' ],
    '200'                                       : [ 'Nokia', 'Asha 200' ],
    '201'                                       : [ 'Nokia', 'Asha 201' ],
    '202'                                       : [ 'Nokia', 'Asha 202' ],
    '203'                                       : [ 'Nokia', 'Asha 203' ],
    '205'                                       : [ 'Nokia', 'Asha 205' ],
    '205.1'                                     : [ 'Nokia', 'Asha 205' ],
    '205.3'                                     : [ 'Nokia', 'Asha 205' ],
    '206'                                       : [ 'Nokia', 'Asha 206' ],
    '206.1'                                     : [ 'Nokia', 'Asha 206' ],
    '208'                                       : [ 'Nokia', '208' ],
    '208.1'                                     : [ 'Nokia', '208' ],
    '208.2'                                     : [ 'Nokia', '208' ],
    '208.3'                                     : [ 'Nokia', '208' ],
    '208.4'                                     : [ 'Nokia', '208' ],
    '210'                                       : [ 'Nokia', 'Asha 210' ],
    '210.2'                                     : [ 'Nokia', 'Asha 210' ],
    '210.3'                                     : [ 'Nokia', 'Asha 210' ],
    '210.4'                                     : [ 'Nokia', 'Asha 210' ],
    '210.5'                                     : [ 'Nokia', 'Asha 210' ],
    '300'                                       : [ 'Nokia', 'Asha 300' ],
    '301'                                       : [ 'Nokia', '301' ],
    '301.1'                                     : [ 'Nokia', '301' ],
    '302'                                       : [ 'Nokia', 'Asha 302' ],
    '303'                                       : [ 'Nokia', 'Asha 303' ],
    '305'                                       : [ 'Nokia', 'Asha 305' ],
    '306'                                       : [ 'Nokia', 'Asha 306' ],
    '308'                                       : [ 'Nokia', 'Asha 308' ],
    '309'                                       : [ 'Nokia', 'Asha 309' ],
    '310'                                       : [ 'Nokia', 'Asha 310' ],
    '311'                                       : [ 'Nokia', 'Asha 311' ],
    '515'                                       : [ 'Nokia', '515' ],
    '515.2'                                     : [ 'Nokia', '515' ],
    '1682c'                                     : [ 'Nokia', '1682 classic' ],
    '2055'                                      : [ 'Nokia', 'Asha 2055' ],
    '2060'                                      : [ 'Nokia', '2060' ],                 // Same as Asha 206
    '2220s!'                                    : [ 'Nokia', '2220 slide' ],
    '2320c!'                                    : [ 'Nokia', '2320 classic' ],
    '2322c!'                                    : [ 'Nokia', '2322 classic' ],
    '2323c!'                                    : [ 'Nokia', '2323 classic' ],
    '2330c!'                                    : [ 'Nokia', '2330 classic' ],
    '2600c!'                                    : [ 'Nokia', '2600 classic' ],
    '2680s!'                                    : [ 'Nokia', '2680 slide' ],
    '2690'                                      : [ 'Nokia', '2690' ],
    '2692'                                      : [ 'Nokia', '2692' ],
    '2700c!'                                    : [ 'Nokia', '2700 classic' ],
    '2710c'                                     : [ 'Nokia', '2710' ],
    '2710c-2'                                   : [ 'Nokia', '2710' ],
    '2720a!'                                    : [ 'Nokia', '2720 fold' ],
    '2730c!'                                    : [ 'Nokia', '2730 classic' ],
    '3020'                                      : [ 'Nokia', '3020' ],
    '3109c'                                     : [ 'Nokia', '3109 classic' ],
    '3110c'                                     : [ 'Nokia', '3110 Evolve' ],
    '3120c'                                     : [ 'Nokia', '3120 classic' ],
    '3120classic'                               : [ 'Nokia', '3120 classic' ],
    '3208c'                                     : [ 'Nokia', '3208 classic' ],
    '3500c'                                     : [ 'Nokia', '3500 classic' ],
    '3555b'                                     : [ 'Nokia', '3555' ],
    '3600s'                                     : [ 'Nokia', '3600 slide' ],
    '3610a'                                     : [ 'Nokia', '3610 fold' ],
    '3710fold'                                  : [ 'Nokia', '3710 fold' ],
    '3720c'                                     : [ 'Nokia', '3720 classic' ],
    '5000!'                                     : [ 'Nokia', '5000' ],
    '5130!'                                     : [ 'Nokia', '5130 XpressMusic' ],
    '5130c!'                                    : [ 'Nokia', '5130 classic' ],
    '5132'                                      : [ 'Nokia', '5132 XpressMusic' ],
    '5200!'                                     : [ 'Nokia', '5200' ],
    '5220!'                                     : [ 'Nokia', '5220 XpressMusic' ],
    '5300!'                                     : [ 'Nokia', '5300 XpressMusic' ],
    '5310!'                                     : [ 'Nokia', '5310 XpressMusic' ],
    '5330'                                      : [ 'Nokia', '5330 Mobile TV Edition' ],
    '5330-1d'                                   : [ 'Nokia', '5330 Mobile TV Edition' ],
    '5610d!'                                    : [ 'Nokia', '5610 XpressMusic' ],
    '6070!'                                     : [ 'Nokia', '6070' ],
    '6208c'                                     : [ 'Nokia', '6208 classic' ],
    '6212c'                                     : [ 'Nokia', '6212 classic' ],
    '6260s!'                                    : [ 'Nokia', '6260 slide' ],
    '6230i!'                                    : [ 'Nokia', '6230i' ],
    '6233'                                      : [ 'Nokia', '6233' ],
    '6234'                                      : [ 'Nokia', '6234' ],
    '6263!'                                     : [ 'Nokia', '6263' ],
    '6280'                                      : [ 'Nokia', '6280' ],
    '6300'                                      : [ 'Nokia', '6300' ],
    '6300i'                                     : [ 'Nokia', '6300i' ],
    '6301'                                      : [ 'Nokia', '6301' ],
    '6303c'                                     : [ 'Nokia', '6303 classic' ],
    '6303classic'                               : [ 'Nokia', '6303 classic' ],
    '6303iclassic'                              : [ 'Nokia', '6303i classic' ],
    '6303ci'                                    : [ 'Nokia', '6303i classic' ],
    '6350'                                      : [ 'Nokia', '6350' ],
    '6500s!'                                    : [ 'Nokia', '6500 slide' ],
    '6600f!'                                    : [ 'Nokia', '6600 fold' ],
    '6600s!'                                    : [ 'Nokia', '6600 slide' ],
    '6600i!'                                    : [ 'Nokia', '6600i slide' ],
    '6700c!'                                    : [ 'Nokia', '6700 classic' ],
    '6750c'                                     : [ 'Nokia', '6750 Mural' ],
    '7070!'                                     : [ 'Nokia', '7070 Prism' ],
    '7100s!'                                    : [ 'Nokia', '7100 Supernova' ],
    '7210s!'                                    : [ 'Nokia', '7210 Supernova' ],
    '7210Supernova!'                            : [ 'Nokia', '7210 Supernova' ],
    '7230!'                                     : [ 'Nokia', '7230' ],
    '7310c!'                                    : [ 'Nokia', '7310 Supernova' ],
    '7500'                                      : [ 'Nokia', '7500 Prism' ],
    '7510Supernova!'                            : [ 'Nokia', '7510 Supernova' ],
    '7610Supernova!'                            : [ 'Nokia', '7610 Supernova' ],
    '8800!'                                     : [ 'Nokia', '8800 Arte' ]
};

/* This file is automatically generated, do not edit manually! */
